import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from '@/mixins/packageTableMixins';
import addAppCustom from './components/addAppCustom';
import customDetails from './components/customDetails.vue';
import config from '@/config/index';
import { building_add, building_list, building_del, building_update } from '@/api/pests';
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      setData: null,
      currClientId: null,
      //当前选择的应用id
      form_filter: {
        project_name: null,
        building_name: null
      },
      //共用的查询与重置
      topButtonList: [{
        name: '查询',
        type: 'primary',
        method: this.search
      }, {
        name: '重置',
        type: 'error',
        method: this.reset
      }],
      //共用的右侧添加按钮
      topButtonList1: [{
        name: '添加',
        icon: 'ios-add',
        type: 'primary',
        method: this.add
      }, {
        name: '刷新',
        icon: 'ios-refresh',
        type: 'primary',
        method: this.init
      }],
      reqBase: {
        page: 1,
        page_size: 15
      },
      status: true,
      //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList: [{
        name: '查看',
        type: 'text',
        icon: '',
        method: this.details
      }, {
        name: '编辑',
        type: 'text',
        icon: '',
        method: this.edit
      }, {
        name: '删除',
        type: 'text',
        icon: '',
        method: this.del
      }],
      operationButtonList1: [{
        name: this.$t('operationModule.submitReview'),
        type: 'primary',
        icon: '',
        method: this.submitReview
      }],
      columnsheader: [// {
      //   align: 'center',
      //   title: '序号',
      //   minWidth:120,
      //   key: 'xuhao',
      // },
      {
        align: 'center',
        title: '平面图名称',
        minWidth: 120,
        key: 'floor_file_name'
      }, {
        align: 'center',
        title: '防制区域名称',
        minWidth: 120,
        key: 'prevent_area_name'
      }, {
        align: 'center',
        title: '所属项目',
        minWidth: 120,
        key: 'project_name'
      }, {
        align: 'center',
        title: '所属建筑物',
        minWidth: 100,
        key: 'building_name'
      }, {
        align: 'center',
        title: '地址',
        minWidth: 120,
        key: 'address'
      }, {
        align: 'center',
        title: '操作',
        minWidth: 150,
        key: 'Operating',
        render: function render(h, _ref) {
          var row = _ref.row;
          var arr = [];

          var _loop = function _loop(i) {
            var list = _this2.operationButtonList[i];
            arr.push(h('Button', {
              style: {
                marginLeft: '5px',
                marginBottom: '3px',
                color: '#2d8cf0'
              },
              props: {
                type: list.type,
                size: list.size ? list.size : 'small'
              },
              on: {
                click: function click() {
                  list.method(row);
                }
              }
            }, list.name));
          };

          for (var i in _this2.operationButtonList) {
            _loop(i);
          }

          return h('div', arr);
        }
      }]
    };
  },
  props: {
    reducehe: {},
    code: {}
  },
  components: {
    customDetails: customDetails
  },
  computed: {},
  methods: {
    mechanHome: function mechanHome(row) {
      window.open(config.webLinkUrl + '/index/' + row.company_code);
    },
    pageSizeChange: function pageSizeChange() {},
    init: function init() {
      var _this3 = this;

      this.tableLoading = true;
      building_list(_objectSpread({}, this.reqBase)).then(function (res) {
        _this3.tableLoading = false;
        _this3.tableDataList = [];

        if (res.result === 0) {
          _this3.tableDataList = res.body.list || [];
          _this3.getPageTotal = res.body.total;
        } else {
          _this3.tableDataList = [];
          _this3.getPageTotal = 0;

          _this3.$Message.error(res.errorMsg);
        }
      });
    },
    //新增
    add: function add() {
      var _this4 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 800,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, '添加'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(addAppCustom, {
            ref: 'addAppCustom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              projectCode: _this4.code
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addAppCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              building_add(formModel).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    search: function search() {
      this.onSearch(this.form_filter);
    },
    reset: function reset() {
      this.form_filter = {
        project_name: null,
        building_name: null
      };
      this.search();
    },
    details: function details(row) {
      var vm = this;
      var config = {
        loading: true,
        width: 800,
        okText: '关闭',
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '15px'
            }
          }, '详情'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h(customDetails, {
            ref: 'customDetails',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          vm.$Modal.remove();
        }
      };
      this.$Modal.success(config);
    },
    edit: function edit(row) {
      var _this5 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 800,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '15px'
            }
          }, '编辑'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h(addAppCustom, {
            ref: 'addAppCustom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              projectCode: _this5.code,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addAppCustom;
          obj.checkForm().then(function (req) {
            if (req) {
              //提交请求
              var formModel = obj.formModel;
              building_update(_objectSpread({}, formModel, {
                company_code: row.company_code
              })).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    del: function del(row) {
      var vm = this;
      var config = {
        loading: true,
        title: this.$t('删除'),
        content: this.$t('您确定要删除') + row.building_name + '?',
        onOk: function onOk() {
          var _this = this;

          building_del({
            id: row.id
          }).then(function (res) {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    }
  },
  mounted: function mounted() {
    if (this.code) {
      this.$set(this.reqBase, 'project_code', this.code);
    }

    if (this.reducehe) {
      this.reduceheight = this.reducehe;
    } else {
      this.init();
    }
  },
  created: function created() {// this.getPageSizeToStorage();
  }
};